var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 44,
    viewBox: "0 0 8 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 43.3536C3.84171 43.5488 4.15829 43.5488 4.35356 43.3536L7.53554 40.1716C7.7308 39.9763 7.7308 39.6597 7.53554 39.4645C7.34027 39.2692 7.02369 39.2692 6.82843 39.4645L4 42.2929L1.17157 39.4645C0.976312 39.2692 0.65973 39.2692 0.464468 39.4645C0.269206 39.6597 0.269206 39.9763 0.464468 40.1716L3.64645 43.3536ZM3.5 2.18557e-08L3.5 43L4.5 43L4.5 -2.18557e-08L3.5 2.18557e-08Z",
    fill: "white",
    fillOpacity: 0.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownArrow);
export default __webpack_public_path__ + "static/media/scroll-down-arrow.b013ca458cf827f32732e3ce3c691d03.svg";
export { ForwardRef as ReactComponent };